import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Button from "../../components/Button";
import { Row, FlexRow, Separator } from "../../components/Base";
import { getUserBillingAddresses } from "../../api/user.deprecated";

import BillingDialog from "./dialog";

const BillingAddressSelector = ({ onSelect }) => {
  const { t } = useTranslation();
  const [addresses, setAddresses] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [showBillingDialog, setShowBillingDialog] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      const addresses = await getUserBillingAddresses();
      setAddresses(addresses);
      const firstAddressId = addresses[0]?.id || "";
      setSelectedId(firstAddressId);
      onSelect(firstAddressId);
    })();
  }, [refresh]);

  const showAddDialog = () => {
    setShowBillingDialog(true);
  };

  const hideDialog = () => {
    setShowBillingDialog(false);
    setRefresh(refresh + 1);
  };

  return (
    <>
      {addresses?.length ? (
        <FlexRow>
          <Select
            label={t("billing.address")}
            value={selectedId || ""}
            onChange={(e) => {
              onSelect(e.target.value);
              setSelectedId(e.target.value);
            }}
          >
            {addresses.map((address) => (
              <MenuItem key={address.id} value={address.id}>
                {address.companyName}; {address.firstName} {address.lastName}, {address.addressLine1}, {address.city}{" "}
                {address.country}
              </MenuItem>
            ))}
          </Select>
          <Separator />
          <div style={{ display: "flex" }}>
            <Button
              onClick={() => {
                setSelectedId("");
                showAddDialog();
              }}
              title={t("billing.add_new_address")}
            >
              {t("billing.add_address")}
            </Button>
            <Separator />
            <Button onClick={showAddDialog} title={t("billing.edit_selected_address")}>
              {t("billing.edit_address")}
            </Button>
          </div>
        </FlexRow>
      ) : (
        <Row>
          <Button onClick={showAddDialog} title={t("billing.add_billing_address")}>
            {t("billing.add_billing_address")}
          </Button>
        </Row>
      )}
      {showBillingDialog && <BillingDialog id={selectedId || ""} done={hideDialog} />}
    </>
  );
};

export default BillingAddressSelector;
